import { createContext, useContext } from 'react';

export type SelectablePartner = {
    Active: boolean;
    ContactEmail?: string;
    Country?: { Id: number; Name: string };
    DateCreate?: string;
    ID: number;
    Name: string;
    Sector?: string;
    State?: { Id: number; Name: string };
    UserList?: string;
};

export type CollectionPermissions = {
    Create: boolean;
    Edit: boolean;
    View: boolean;
};

type CollectionsContextValue = {
    availablePartners: SelectablePartner[];
    permissions: CollectionPermissions;
    showAdvancedColumns: boolean;
    showLoginFields: boolean;
};

export const CollectionsContext = createContext<CollectionsContextValue>({
    availablePartners: [],
    permissions: {
        Create: false,
        Edit: false,
        View: false
    },
    showAdvancedColumns: false,
    showLoginFields: false
});

export const useCollections = () => useContext(CollectionsContext);
